"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CircleAlertIcon } from "lucide-react";
import { useTypedTranslations } from "@/i18n/typed";
import { Typography } from "@/components/custom/typography";

const CATEGORY_KEYS = [
  "consumer",
  "fashion",
  "electronics",
  "mobility",
  "finance",
  "telecom",
  "travel",
  "education",
  "health",
  "living",
  "franchise",
  "realestate",
  "others",
] as const;

export default function ProductCategoryNoteList() {
  const t = useTypedTranslations("search");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <CircleAlertIcon className="size-3 cursor-pointer" />
      </TooltipTrigger>

      <TooltipContent align="start" className="w-[330px] shadow-xl/20 border-0">
        <Typography
          variant="body2"
          className="mb-2.5 font-semibold"
          tone="strong"
        >
          | {t("productCategoryNote.title")}
        </Typography>

        <div className="border-l border-t border-gray-300 text-xs">
          {CATEGORY_KEYS.map((key) => (
            <div key={key} className="flex">
              <div className="border-b w-[130px] flex items-center border-r border-gray-300 bg-gray-200 px-1.5 py-1 ">
                <Typography variant="body3" tone="medium">
                  {" "}
                  {t(`productCategoryNote.categories.${key}.name`)}
                </Typography>
              </div>
              <div className="border-b border-r flex-1 border-gray-300 px-1.5 py-1">
                <Typography variant="body3">
                  {t(`productCategoryNote.categories.${key}.items`)}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
